export const sortArrayByAttribute = <T>(
  arrayToSort: T[],
  nameOfAttribute: string,
  sortByType: 'date' | 'string' | 'number' = 'number',
): T[] => {
  if (arrayToSort.length <= 1) {
    return arrayToSort;
  }

  const sortFunction: (a: T, b: T) => number =
    sortByType === 'date'
      ? (a, b) =>
          new Date((b as unknown as { [key: string]: string })[nameOfAttribute]).getTime() -
          new Date((a as unknown as { [key: string]: string })[nameOfAttribute]).getTime()
      : sortByType === 'string'
        ? (a, b) =>
            ((b as unknown as { [key: string]: string })[nameOfAttribute] as string).localeCompare(
              (a as unknown as { [key: string]: string })[nameOfAttribute] as string,
            )
        : (a, b) =>
            ((b as unknown as { [key: string]: number })[nameOfAttribute] as number) -
            ((a as unknown as { [key: string]: number })[nameOfAttribute] as number);

  return arrayToSort.sort(sortFunction);
};
